import {
  Button,
  Flex,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
} from "@chakra-ui/react";
import { FiDownload } from "react-icons/fi";
import useSWR from "swr";
import baseService from "../../services/base";
import Loader from "../Feedback/Loader";
import { decodificarNomeDeUpload } from "../../utils/nome-de-upload";

async function fetchInlineUrl(url) {
  const response = await baseService.get(url);
  return response?.data;
}

// Redesign "Drive" — preview inline de imagem/PDF ao clicar num card de
// arquivo. Qualquer outro tipo (mime_type) cai no fallback "sem preview",
// só com o botão de baixar (mesmo comportamento de hoje pra esses casos).
export default function FilePreviewModal({ isOpen, onClose, media, onDownload }) {
  const isImage = media?.mime_type?.startsWith("image/");
  const isPdf = media?.mime_type === "application/pdf";
  const canPreview = isImage || isPdf;
  const nome = decodificarNomeDeUpload(media?.name);

  const { data, isLoading } = useSWR(
    isOpen && media && canPreview
      ? `/document/media/${media.id_media}/download-url?inline=true`
      : null,
    fetchInlineUrl
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={canPreview ? "3xl" : "md"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{nome}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {!canPreview && (
            <Text color="#818A8F" fontSize="sm">
              Sem preview disponível pra esse tipo de arquivo.
            </Text>
          )}

          {canPreview && isLoading && <Loader />}

          {canPreview && !isLoading && isImage && data?.url && (
            <Image src={data.url} alt={nome} maxH="70vh" mx="auto" />
          )}

          {canPreview && !isLoading && isPdf && data?.url && (
            <iframe
              src={data.url}
              title={nome}
              style={{ width: "100%", height: "70vh", border: "none" }}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Flex gap="12px">
            <Button variant="outline" onClick={onClose}>
              Fechar
            </Button>
            <Button
              variant="primary"
              leftIcon={<FiDownload />}
              onClick={() => onDownload(media.id_media)}
            >
              Baixar
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
